import { ActionIcon, Group, TextInput } from "@mantine/core";
import { IconX } from "@tabler/icons-react";
import { useDebouncedValue } from "@mantine/hooks";
import { useEffect, useState } from "react";

interface AccountFiltersProps {
	searchTerm: string;
	onSearchChange: (value: string) => void;
}

function AccountFilters({ searchTerm, onSearchChange }: AccountFiltersProps) {
	const [localSearchTerm, setLocalSearchTerm] = useState(searchTerm);
	const [debouncedSearchTerm] = useDebouncedValue(localSearchTerm, 500);

	useEffect(() => {
		onSearchChange(debouncedSearchTerm);
	}, [debouncedSearchTerm, onSearchChange]);

	useEffect(() => {
		setLocalSearchTerm(searchTerm);
	}, [searchTerm]);

	return (
		<Group mb="md">
			<TextInput
				placeholder="Search accounts..."
				value={localSearchTerm}
				onChange={(event) => setLocalSearchTerm(event.currentTarget.value)}
				style={{ flex: 1 }}
				rightSection={
					localSearchTerm ? (
						<ActionIcon
							variant="subtle"
							color="gray"
							onClick={() => setLocalSearchTerm("")}
							aria-label="Clear search">
							<IconX size={16} />
						</ActionIcon>
					) : null
				}
			/>
		</Group>
	);
}

export default AccountFilters;
